import {
  FCCustomizationsClient,
  ClassificationsClient,
  FeatureCatalogsClient,
  CustomFeatureCatalogsClient,
  ConversionRulesClient,
  AttributeTypeCreateRequest,
  AttributeTypeGroupCreateRequest,
  AttributeTypeGroupUpdateRequest,
  FCCustomizationReference,
  CustomFeatureCatalogSimple,
  FeatureTypeCreateRequest,
  FeatureTypeUpdateRequest,

  ///////////////////////////////////////////////
  // Temporary solution for issue with NSWAG Studio client side API generation:
  // https://github.com/RicoSuter/NSwag/issues/2706
  //
  ProblemDetails,
  ValidationProblemDetails,
  SwaggerException,
  CustomAttributeType,
  CustomFeatureCatalog,
  FileResponse,
  AnyFeatureCatalogsClient,
  FCAttributeType,
  AnyFeatureCatalog,
  TypeSearchResult
  ///////////////////////////////////////////////
} from "./generated/QuadriConfigurationApi"

import {
  FeatureCatalog,
  AnyFeatureCatalogInfo,
  CoClassCreateRequest,
  ClassificationHeader,
  AttributeTypeGroup,
  AttributeType,
  // AttributeDataTypes,
  FeatureTypeGroup,
  FeatureType,
  FCFeatureType,
  CustomFeatureType,
  UserInfo,
  Project,
  ProjectHeader,
  Classification,
  MappedClassification,
  AttributeTypeGroupUsage,
  AttributeTypeGroupUsageUpdateRequest,
  LegalAttributeValue,
  UserRole,
  UserRoleUpdateRequest,
  UserRoleCreateRequest,
  StreamVersions,
  Language,
  ConversionRule,
  ConversionRuleCreateRequest,
  ConversionRuleUpdateRequest,
  FCCustomizationImportProgress
} from "./types"
import { GetUserInfo } from "./get_user_auth_service"
import Environment from "../environment"

export interface Api {
  getUserInfo(): UserInfo
  getFeatureCatalogCustomization(id: string): Promise<Project>
  getFeatureCatalogCustomizations(): Promise<ProjectHeader[]>
  createFeatureCatalogCustomization(fcCustomization: Project): Promise<Project>
  deleteFeatureCatalogCustomization(id: string): Promise<void>
  updateFeatureCatalogCustomization(id: string | null, fcCustomization: Project): Promise<Project>
  getFCCustomizationClassifications(id: string): Promise<ClassificationHeader[]>
  exportFeatureCatalogCustomizationToExcel(id: string, includeIds?: boolean | undefined): Promise<FileResponse>
  updateFeatureCatalogCustomizationFeatureTypesFromExcel(id: string, file: File): Promise<FCCustomizationImportProgress>
  importFeatureCatalogCustomizationFromExcel(id: string, file: File): Promise<FCCustomizationImportProgress>
  getFccImportProgress(fccId: string, ticketId: string): Promise<FCCustomizationImportProgress>

  // Versions
  createFeatureCatalogCustomizationVersion(fccId: string, fcCustomization: Project): Promise<Project>

  getCustomFeatureCatalogs(fccId?: string): Promise<CustomFeatureCatalog[]>

  publishFeatureCatalogCustomization(fccReferance: FCCustomizationReference): Promise<CustomFeatureCatalogSimple>

  getClassifications(): Promise<Classification[]>
  getClassification(id: string): Promise<Classification>
  createClassification(request: CoClassCreateRequest): Promise<Classification>
  postClassificationToFcc(
    fccId: string,
    fccVersionNumber: number,
    classificationMapped: MappedClassification
  ): Promise<MappedClassification>
  updateClassification(id: string): Promise<Classification>
  deleteClassification(id: string): Promise<void>

  getAttributeTypeGroups(id: string): Promise<AttributeTypeGroup[]>

  getAttributeTypeGroup(fccId: string, atgId: number): Promise<AttributeTypeGroup>
  createAttributeTypeGroup(fccId: string, attrTypeGroup: AttributeTypeGroupCreateRequest): Promise<AttributeTypeGroup>
  deleteAttributeTypeGroup(fccId: string, atgId: number): Promise<void>
  updateAttributeTypeGroup(
    fccId: string,
    atgId: number,
    attrTypeGroup: AttributeTypeGroupUpdateRequest
  ): Promise<AttributeTypeGroup>

  getAttributeTypesByGroup(fccId: string, atgId: number): Promise<CustomAttributeType[]>
  getAttributeType(fccId: string, atId: number): Promise<CustomAttributeType>
  createAttributeType(fccId: string, atgId: number, attr: AttributeTypeCreateRequest): Promise<CustomAttributeType>
  updateAttributeType(fccId: string, atId: number, attrType: CustomAttributeType): Promise<CustomAttributeType>
  deleteAttributeType(fccId: string, atId: number): Promise<void>

  getAnyFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    compatibleFcId?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined
  ): Promise<AnyFeatureCatalog[]>

  getAnyFeatureCatalogInfo(fcId: string): Promise<AnyFeatureCatalogInfo>

  getAnyFeatureCatalogLanguages(fcId: string): Promise<Language[]>

  getFeatureCatalogs(
    standard?: string,
    minimumVersion?: string,
    maximumStreamVersion?: string
  ): Promise<FeatureCatalog[]>

  getFeatureTypes(fcId: string): Promise<FeatureType[]>
  getFeatureTypeGroups(fcId: string): Promise<FeatureTypeGroup[]>

  getAnyFeatureTypesByGroup(fcId: string, ftgId: number, language: string | null | undefined): Promise<FeatureType[]>
  getAnyFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]>
  getAnyFeatureTypeGroup(fcId: string, ftgId: number, language: string | null | undefined): Promise<FeatureTypeGroup>
  getAnyFeatureType(fcId: string, ftId: number, includeInheritance: boolean, language: string | null | undefined): Promise<FCFeatureType>
  getAnyFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]>
  getAnyAttributeType(fcId: string, atId: number, language: string | null | undefined): Promise<FCAttributeType>

  searchForTypes(
    fcId: string | null,
    search: string | null,
    categories?: string | null | undefined,
    limit?: number | undefined,
    offset?: number | undefined,
    language?: string | null | undefined
  ): Promise<TypeSearchResult>

  getAttributeTypeGroupAssociations(fccId: string, atgId: number): Promise<AttributeTypeGroupUsage>
  updateAttributeTypeGroupAssociation(
    fccId: string,
    atgId: number,
    atgUsageUpdateRequest: AttributeTypeGroupUsageUpdateRequest
  ): Promise<AttributeTypeGroupUsage>

  addAttributeLegalValue(fccId: string, atId: number, value: LegalAttributeValue): Promise<LegalAttributeValue>
  removeAttributeLegalValue(fccId: string, atId: number, lvId: number): Promise<void>
  getAttributeLegalValues(fccId: string, atId: number): Promise<LegalAttributeValue[]>
  getAttributeLegalValuesCsv(fccId: string, atId: number): Promise<any>
  updateAttributeLegalValue(
    fccId: string,
    atId: number,
    lvId: number,
    value: LegalAttributeValue
  ): Promise<LegalAttributeValue>

  updateAttributeLegalValues(
    fccId: string,
    atId: number,
    allValues: LegalAttributeValue[]
  ): Promise<LegalAttributeValue[]>
  updateAttributeLegalValuesCSV(fccId: string, atId: number, file: File): Promise<LegalAttributeValue[]>

  getCustomFeatureTypes(fccId: string): Promise<CustomFeatureType[]>
  createCustomFeatureType(fccId: string, featType: FeatureTypeCreateRequest): Promise<CustomFeatureType>
  getCustomFeatureType(fccId: string, ftId: number): Promise<CustomFeatureType>
  updateCustomFeatureType(fccId: string, ftId: number, featType: FeatureTypeUpdateRequest): Promise<CustomFeatureType>
  deleteCustomFeatureType(fccId: string, ftId: number): Promise<void>

  getFCCUserRoles(fccId: string): Promise<UserRole[]>
  updateFCCUserRole(fccId: string, userIdOrEmail: string, userRoleUpdate: UserRoleUpdateRequest): Promise<UserRole>
  createFCCUserRole(fccId: string, userRoleUpdate: UserRoleCreateRequest): Promise<UserRole>
  deleteFCCUserRole(fccId: string, userIdOrEmail: string): Promise<void>

  // Conversion Rules
  getConversionRules(): Promise<ConversionRule[]>
  createConversionRule(crCreateRequest: ConversionRuleCreateRequest): Promise<ConversionRule>
  getConversionRule(crId: string): Promise<ConversionRule>
  updateConversionRule(crId: string, crUpdateRequest: ConversionRuleUpdateRequest): Promise<ConversionRule>
  deleteConversionRule(crId: string): Promise<void>
}

let api: ApiImpl | undefined

export async function GetApi(): Promise<Api> {
  if (!api) {
    api = await createApi()
  }
  return api
}

function updateApiUser(user: UserInfo) {
  if (api) {
    api.updateUser(user)
  }
}

async function createApi(): Promise<ApiImpl> {
  const userInfo = await GetUserInfo(updateApiUser)
  // const userInfo = await GetUserInfo();
  return new ApiImpl(userInfo as UserInfo)
}

export class ApiImpl implements Api {
  ///////////////////////////////////////////////
  // Temporary solution for issue with NSWAG Studio client side API generation:
  // https://github.com/RicoSuter/NSwag/issues/2706
  //
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined
  ///////////////////////////////////////////////

  private http = this.getHttp()
  private userInfo: UserInfo

  private anyFeatureCatalogsApi: AnyFeatureCatalogsClient
  private customFeatureCatalogsApi: CustomFeatureCatalogsClient
  private fcCustomizationApi: FCCustomizationsClient
  private featureCatalogsApi: FeatureCatalogsClient
  private classificationsApi: ClassificationsClient
  private conversionRulesApi: ConversionRulesClient

  constructor(userInfo: UserInfo) {
    console.log("user info: ", userInfo)

    if (!userInfo.idToken) {
      throw new Error("Missing access token")
    }

    this.userInfo = userInfo

    this.anyFeatureCatalogsApi = new AnyFeatureCatalogsClient(baseUrl, this.http)
    this.customFeatureCatalogsApi = new CustomFeatureCatalogsClient(baseUrl, this.http)
    this.fcCustomizationApi = new FCCustomizationsClient(baseUrl, this.http)
    this.featureCatalogsApi = new FeatureCatalogsClient(baseUrl, this.http)
    this.classificationsApi = new ClassificationsClient(baseUrl, this.http)
    this.conversionRulesApi = new ConversionRulesClient(baseUrl, this.http)
  }

  public updateUser(user: UserInfo) {
    console.log("updating user info")
    this.userInfo = user
  }

  public getUserInfo(): UserInfo {
    return this.userInfo
  }

  public async getFeatureCatalogCustomization(id: string) {
    return this.fcCustomizationApi.getFCCustomization(id)
  }

  public async getFeatureCatalogCustomizations() {
    return this.fcCustomizationApi.getFCCustomizations()
  }

  public async getFCCustomizationClassifications(id: string) {
    return this.fcCustomizationApi.getClassifications(id, 1) // TODO: What is this version??
  }

  public async createFeatureCatalogCustomization(fcCustomization: Project): Promise<Project> {
    return this.fcCustomizationApi.createFCCustomization(fcCustomization)
  }

  public async deleteFeatureCatalogCustomization(id: string): Promise<void> {
    return this.fcCustomizationApi.deleteFCCustomization(id)
  }

  public async updateFeatureCatalogCustomization(id: string, fcCustomization: Project): Promise<Project> {
    return this.fcCustomizationApi.updateFCCustomization(id, fcCustomization)
  }

  public async createFeatureCatalogCustomizationVersion(fccId: string, fcCustomization: Project): Promise<Project> {
    return this.fcCustomizationApi.createFCCustomizationVersion(fccId, fcCustomization)
  }

  public async getCustomFeatureCatalogs(standard?: string): Promise<CustomFeatureCatalog[]> {
    return this.customFeatureCatalogsApi.getCustomFeatureCatalogs(standard, undefined, StreamVersions.SV_4211, undefined, true)
  }

  public async getAnyFeatureCatalogs(
    standard?: string | null | undefined,
    minimumVersion?: string | null | undefined,
    compatibleFcId?: string | null | undefined,
    maximumStreamVersion?: string | null | undefined,
    tags?: string | null | undefined
  ): Promise<AnyFeatureCatalog[]> {
    return this.anyFeatureCatalogsApi.getAnyFeatureCatalogs(
      standard,
      minimumVersion,
      compatibleFcId,
      maximumStreamVersion,
      tags,
      true
    )
  }

  public async getAnyFeatureCatalogInfo(fcId: string): Promise<AnyFeatureCatalogInfo> {
    return this.anyFeatureCatalogsApi.getAnyFeatureCatalogInfo(fcId)
  }

  public async getAnyFeatureCatalogLanguages(fcId: string): Promise<Language[]> {
    return this.anyFeatureCatalogsApi.getLanguages(fcId)
  }

  public async exportFeatureCatalogCustomizationToExcel(
    id: string,
    includeIds?: boolean | undefined
  ): Promise<FileResponse> {
    return this.fcCustomizationApi.exportFCCustomizationToExcel(id, includeIds)
  }

  public async updateFeatureCatalogCustomizationFeatureTypesFromExcel(
    id: string,
    file: File
  ): Promise<FCCustomizationImportProgress> {
    return this.fcCustomizationApi.updateFeatureTypesExcel(id, {data: file, fileName: file.name})
  }

  public async importFeatureCatalogCustomizationFromExcel(
    id: string, 
    file: File
  ): Promise<FCCustomizationImportProgress> {
    return this.fcCustomizationApi.importFCCustomizationFromExcel(id, {data: file, fileName: file.name})
  }

  public async getFccImportProgress(
    fccId: string,
    ticketId: string
  ): Promise<FCCustomizationImportProgress> {
    return this.fcCustomizationApi.getFccImportProgress(fccId, ticketId)
  }

  public async publishFeatureCatalogCustomization(
    fccReferance: FCCustomizationReference
  ): Promise<CustomFeatureCatalogSimple> {
    return this.customFeatureCatalogsApi.publishCustomFeatureCatalog(fccReferance)
  }

  public async getFeatureCatalogs(
    standard?: string,
    minimumVersion?: string,
    maximumStreamVersion?: string
  ): Promise<FeatureCatalog[]> {
    return this.featureCatalogsApi.getFeatureCatalogs(
      standard,
      minimumVersion,
      maximumStreamVersion === undefined ? StreamVersions.SV_4211 : maximumStreamVersion,
      undefined,
      true
    ) // Magic number...
  }

  public async createClassification(request: CoClassCreateRequest): Promise<Classification> {
    return this.classificationsApi.createClassificationFromCoClassService(request)
  }

  public async postClassificationToFcc(
    fccId: string,
    fccVersionNumber: number,
    classificationMapped: MappedClassification
  ): Promise<MappedClassification> {
    return this.fcCustomizationApi.createClassificationUsage(fccId, fccVersionNumber, classificationMapped)
  }

  public async getClassifications() {
    return this.classificationsApi.getAccessibleClassifications()
  }

  public async getClassification(id: string): Promise<Classification> {
    return this.classificationsApi.getClassification(id)
  }

  public async updateClassification(id: string): Promise<Classification> {
    return this.classificationsApi.refreshClassificationFromCoClassService(id)
  }

  public async deleteClassification(id: string): Promise<void> {
    return this.classificationsApi.deleteClassification(id)
  }

  public async getAttributeTypeGroups(id: string) {
    return this.fcCustomizationApi.getAttributeTypeGroups(id)
  }

  public async getAttributeTypeGroup(fccId: string, atgId: number): Promise<AttributeTypeGroup> {
    return this.fcCustomizationApi.getAttributeTypeGroup(fccId, atgId)
  }

  public async createAttributeTypeGroup(
    fccId: string,
    attrTypeGroup: AttributeTypeGroupCreateRequest
  ): Promise<AttributeTypeGroup> {
    return this.fcCustomizationApi.createAttributeTypeGroup(fccId, attrTypeGroup)
  }

  public async updateAttributeTypeGroup(
    fccId: string,
    atgId: number,
    attrTypeGroup: AttributeTypeGroupUpdateRequest
  ): Promise<AttributeTypeGroup> {
    return this.fcCustomizationApi.updateAttributeTypeGroup(fccId, atgId, attrTypeGroup)
  }

  public async deleteAttributeTypeGroup(fccId: string, atgId: number): Promise<void> {
    return this.fcCustomizationApi.deleteAttributeTypeGroup(fccId, atgId)
  }

  public async getAttributeTypesByGroup(fccId: string, atgId: number): Promise<CustomAttributeType[]> {
    return this.fcCustomizationApi.getAttributeTypesByGroup(fccId, atgId)
  }

  public async getAttributeType(fccId: string, atId: number): Promise<CustomAttributeType> {
    return this.fcCustomizationApi.getAttributeType(fccId, atId)
  }

  public async createAttributeType(
    fccId: string,
    atgId: number,
    attr: AttributeTypeCreateRequest
  ): Promise<CustomAttributeType> {
    return this.fcCustomizationApi.createAttributeType(fccId, atgId, attr)
  }

  public async updateAttributeType(fccId: string, atId: number, attrType: AttributeType): Promise<CustomAttributeType> {
    return this.fcCustomizationApi.updateAttributeType(fccId, atId, attrType)
  }

  public async getFeatureTypes(fcId: string): Promise<FeatureType[]> {
    return this.featureCatalogsApi.getFeatureTypes(fcId)
  }

  public async getAnyFeatureTypeGroup(fcId: string, ftgId: number, language: string | null | undefined): Promise<FeatureTypeGroup> {
    return this.anyFeatureCatalogsApi.getFeatureTypeGroup(fcId, ftgId, language)
  }

  public async getAnyFeatureType(fcId: string, ftId: number, includeInheritance: boolean, language: string | null | undefined): Promise<FCFeatureType> {
    return this.anyFeatureCatalogsApi.getFeatureType(fcId, ftId, includeInheritance, language);
  }

  public async getAnyFeatureTypes(fcId: string, language?: string | null | undefined): Promise<FeatureType[]> {
    return this.anyFeatureCatalogsApi.getFeatureTypes(fcId, language);
  }

  public async getAnyAttributeType(fcId: string, atId: number, language: string | null | undefined): Promise<FCAttributeType> {
    return this.anyFeatureCatalogsApi.getAttributeType(fcId, atId, language);
  }

  public async searchForTypes(fcId: string, search: string, categories?: string | null | undefined, limit?: number | undefined,
    offset?: number | undefined, language?: string | null | undefined): Promise<TypeSearchResult> {
    return this.anyFeatureCatalogsApi.searchForTypes(fcId, search, undefined, undefined, undefined, language);
  }

  public async getFeatureTypeGroups(fcId: string): Promise<FeatureTypeGroup[]> {
    return this.featureCatalogsApi.getFeatureTypeGroups(fcId)
  }

  public async getAnyFeatureTypesByGroup(fcId: string, ftgId: number, language?: string | null | undefined): Promise<FeatureType[]> {
    return this.anyFeatureCatalogsApi.getFeatureTypesInGroup(fcId, ftgId, language)
  }

  public async getAnyFeatureTypeGroups(fcId: string, language?: string | null | undefined): Promise<FeatureTypeGroup[]> {
    return this.anyFeatureCatalogsApi.getFeatureTypeGroups(fcId, language)
  }

  public async getAttributeTypeGroupAssociations(fccId: string, atgId: number): Promise<AttributeTypeGroupUsage> {
    return this.fcCustomizationApi.getAttributeTypesGroupAssociations(fccId, atgId)
  }

  public async updateAttributeTypeGroupAssociation(
    fccId: string,
    atgId: number,
    atgUsageUpdateRequest: AttributeTypeGroupUsageUpdateRequest
  ): Promise<AttributeTypeGroupUsage> {
    return this.fcCustomizationApi.updateAttributeTypesGroupAssociations(fccId, atgId, atgUsageUpdateRequest)
  }

  public async addAttributeLegalValue(
    fccId: string,
    atId: number,
    value: LegalAttributeValue
  ): Promise<LegalAttributeValue> {
    return this.fcCustomizationApi.createLegalValueOfAttributeType(fccId, atId, value as any)
  }

  public async removeAttributeLegalValue(fccId: string, atId: number, lvId: number): Promise<void> {
    return this.fcCustomizationApi.deleteLegalValueOfAttributeType(fccId, atId, lvId)
  }

  public async getAttributeLegalValues(fccId: string, atId: number): Promise<LegalAttributeValue[]> {
    return this.fcCustomizationApi.getLegalValuesOfAttributeType(fccId, atId)
  }

  public async getAttributeLegalValuesCsv(fccId: string, atId: number): Promise<any> {
    let url = baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues"
    if (fccId === undefined || fccId === null) {
      throw new Error("The parameter 'fccId' must be defined.")
    }
    url = url.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) {
      throw new Error("The parameter 'atId' must be defined.")
    }
    url = url.replace("{atId}", encodeURIComponent("" + atId))
    url = url.replace(/[?&]$/, "")

    const options = {
      method: "GET",
      headers: { Accept: "text/csv" }
    } as RequestInit

    return this.http.fetch(url, options).then((response: Response) => {
      const status = response.status
      const headers: any = {}
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (headers[k] = v))
      }
      if (status === 200) {
        return response.text().then((responseText) => {
          return responseText
        })
      } else if (status === 401) {
        return response.text().then((responseText) => {
          return throwException("Authorization information is missing or invalid.", status, responseText, headers)
        })
      } else if (status === 403) {
        return response.text().then((responseText) => {
          let result403: any = null
          result403 = responseText === "" ? null : (JSON.parse(responseText, this.jsonParseReviver) as ProblemDetails)
          return throwException(
            "User is not authorized to access this resource.",
            status,
            responseText,
            headers,
            result403
          )
        })
      } else if (status === 404) {
        return response.text().then((responseText) => {
          let result404: any = null
          result404 = responseText === "" ? null : (JSON.parse(responseText, this.jsonParseReviver) as ProblemDetails)
          return throwException(
            "The feature catalog customization or attribute type with the specified ID was not found.",
            status,
            responseText,
            headers,
            result404
          )
        })
      } else if (status !== 200 && status !== 204) {
        return response.text().then((responseText) => {
          return throwException("An unexpected server error occurred.", status, responseText, headers)
        })
      }
      return Promise.resolve<LegalAttributeValue[]>(null as any)
    })
  }

  public async updateAttributeLegalValue(
    fccId: string,
    atId: number,
    lvId: number,
    value: LegalAttributeValue
  ): Promise<LegalAttributeValue> {
    return this.fcCustomizationApi.updateLegalValueOfAttributeType(fccId, atId, lvId, value)
  }

  public async updateAttributeLegalValues(
    fccId: string,
    atId: number,
    allValues: LegalAttributeValue[]
  ): Promise<LegalAttributeValue[]> {
    return this.fcCustomizationApi.updateLegalValuesOfAttributeType(fccId, atId, allValues)
  }

  ///////////////////////////////////////////////
  // public async updateAttributeLegalValuesCSV(fccId: string, atId: number, allValues: LegalAttributeValue[]): Promise<LegalAttributeValue[]> {
  //   return this.fcCustomizationApi.updateLegalValuesOfAttributeType(fccId, atId, allValues);
  // }
  //
  // Temporary solution for issue with NSWAG Studio client side API generation:
  // https://github.com/RicoSuter/NSwag/issues/2706
  //
  public async updateAttributeLegalValuesCSV(fccId: string, atId: number, file: File): Promise<LegalAttributeValue[]> {
    let url = baseUrl + "/api/v2/fcCustomizations/{fccId}/attributeTypes/{atId}/legalValues"
    if (fccId === undefined || fccId === null) {
      throw new Error("The parameter 'fccId' must be defined.")
    }
    url = url.replace("{fccId}", encodeURIComponent("" + fccId))
    if (atId === undefined || atId === null) {
      throw new Error("The parameter 'atId' must be defined.")
    }
    url = url.replace("{atId}", encodeURIComponent("" + atId))
    url = url.replace(/[?&]$/, "")

    return this.http
      .fetch(url, {
        body: file,
        method: "PUT",
        headers: {
          "Content-Type": "text/csv",
          Accept: "application/json"
        }
      })
      .then((response) => {
        const status = response.status
        const headers: any = {}
        if (response.headers && response.headers.forEach) {
          response.headers.forEach((v: any, k: any) => (headers[k] = v))
        }
        if (status === 200) {
          return response.text().then((responseText) => {
            let result200: any = null
            result200 =
              responseText === "" ? null : (JSON.parse(responseText, this.jsonParseReviver) as LegalAttributeValue[])
            return result200
          })
        } else if (status === 400) {
          return response.text().then((responseText) => {
            let result400: any = null
            result400 =
              responseText === "" ? null : (JSON.parse(responseText, this.jsonParseReviver) as ValidationProblemDetails)
            return throwException(
              "Bad request. One or more validation errors.",
              status,
              responseText,
              headers,
              result400
            )
          })
        } else if (status === 401) {
          return response.text().then((responseText) => {
            return throwException("Authorization information is missing or invalid.", status, responseText, headers)
          })
        } else if (status === 403) {
          return response.text().then((responseText) => {
            let result403: any = null
            result403 = responseText === "" ? null : (JSON.parse(responseText, this.jsonParseReviver) as ProblemDetails)
            return throwException(
              "User is not authorized to modify this resource.",
              status,
              responseText,
              headers,
              result403
            )
          })
        } else if (status === 404) {
          return response.text().then((responseText) => {
            let result404: any = null
            result404 = responseText === "" ? null : (JSON.parse(responseText, this.jsonParseReviver) as ProblemDetails)
            return throwException(
              "The feature catalog customization or attribute type with the specified ID was not found.",
              status,
              responseText,
              headers,
              result404
            )
          })
        } else if (status === 405) {
          return response.text().then((responseText) => {
            let result405: any = null
            result405 = responseText === "" ? null : (JSON.parse(responseText, this.jsonParseReviver) as ProblemDetails)
            return throwException(
              "The current version of the feature catalog customization can not be modified, published legal values cannot be removed or the specified attribute type doesn't support legal values.",
              status,
              responseText,
              headers,
              result405
            )
          })
        } else if (status !== 200 && status !== 204) {
          return response.text().then((responseText) => {
            return throwException("An unexpected server error occurred.", status, responseText, headers)
          })
        }
        return Promise.resolve<LegalAttributeValue[]>(null as any)
      })
  }
  ///////////////////////////////////////////////

  public async deleteAttributeType(fccId: string, atId: number): Promise<void> {
    return this.fcCustomizationApi.deleteAttributeType(fccId, atId)
  }

  public async getFCCUserRoles(fccId: string): Promise<UserRole[]> {
    return this.fcCustomizationApi.getUserRoles(fccId)
  }

  public async updateFCCUserRole(
    fccId: string,
    userIdOrEmail: string,
    userRoleUpdate: UserRoleUpdateRequest
  ): Promise<UserRole> {
    return this.fcCustomizationApi.updateUserRole(fccId, userIdOrEmail, userRoleUpdate)
  }

  public async createFCCUserRole(fccId: string, userRole: UserRoleCreateRequest): Promise<UserRole> {
    return this.fcCustomizationApi.createUserRole(fccId, userRole)
  }

  public async deleteFCCUserRole(fccId: string, userIdOrEmail: string): Promise<void> {
    return this.fcCustomizationApi.deleteUserRole(fccId, userIdOrEmail)
  }

  public async getCustomFeatureTypes(fccId: string): Promise<CustomFeatureType[]> {
    return this.fcCustomizationApi.getFeatureTypes(fccId)
  }

  public async createCustomFeatureType(fccId: string, featType: FeatureTypeCreateRequest): Promise<CustomFeatureType> {
    return this.fcCustomizationApi.createFeatureType(fccId, featType)
  }

  public async getCustomFeatureType(fccId: string, ftId: number): Promise<CustomFeatureType> {
    return this.fcCustomizationApi.getFeatureType(fccId, ftId)
  }

  public async updateCustomFeatureType(
    fccId: string,
    ftId: number,
    featType: FeatureTypeUpdateRequest
  ): Promise<CustomFeatureType> {
    return this.fcCustomizationApi.updateFeatureType(fccId, ftId, featType)
  }

  public async deleteCustomFeatureType(fccId: string, ftId: number): Promise<void> {
    return this.fcCustomizationApi.deleteFeatureType(fccId, ftId)
  }

  public async getConversionRules(): Promise<ConversionRule[]> {
    return this.conversionRulesApi.getConversionRules()
  }

  public async createConversionRule(crCreateRequest: ConversionRuleCreateRequest): Promise<ConversionRule> {
    return this.conversionRulesApi.createConversionRule(crCreateRequest)
  }
  
  public async getConversionRule(crId: string): Promise<ConversionRule> {
    return this.conversionRulesApi.getConversionRule(crId)
  }

  public async updateConversionRule(crId: string, crUpdateRequest: ConversionRuleUpdateRequest): Promise<ConversionRule> {
    return this.conversionRulesApi.updateConversionRule(crId, crUpdateRequest)
  }

  public async deleteConversionRule(crId: string): Promise<void> {
    return this.conversionRulesApi.deleteConversionRule(crId)
  }
 

  private getHttp() {
    const newFetch = async (url: RequestInfo, init?: RequestInit): Promise<Response> => {
      const bearerAuth = "Bearer " + this.userInfo.accessToken
      const initOpts = init || {}
      const options = {
        ...init,
        headers: {
          ...initOpts.headers,
          Authorization: bearerAuth
          // 'X-JWT-Assertion': this.userInfo.idToken!
        }
      }
      return fetch(url, options)
    }
    return { fetch: newFetch }
  }
}

const baseUrl = Environment.apiBaseUrl

///////////////////////////////////////////////
// Temporary solution for issue with NSWAG Studio client side API generation:
// https://github.com/RicoSuter/NSwag/issues/2706
//
function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) {
    throw result
  } else {
    throw new SwaggerException(message, status, response, headers, null)
  }
}
///////////////////////////////////////////////
